import { BaseDefaultStatusesColumn } from '@enums/base'
import { EUserRoles, EUserSmallRoles } from '@enums/roles'
import { IDyatel, IStatuses } from '@dto/user/userInfo.dto'
import { ExpensesReason } from '@dto/salary/expenses.dto'
import { SubscriptionStatus, SubscriptionType } from '@enums/subscription'
import { UpdateCrmTabsType } from '@components/Modals/UpdateCrm/enums'
import { TariffTypeEnum } from '@interfaces/tariff.interface'
import { ClientCabinetType } from '@enums/cabinetTypes'

// export const statusesArray: Exclude<
//   BaseDefaultStatusesColumn,
//   BaseDefaultStatusesColumn.RECALL | BaseDefaultStatusesColumn.TRANSMIT
// >[] = [
//   BaseDefaultStatusesColumn.SMARTERME,
//   BaseDefaultStatusesColumn.SLIV,
//   BaseDefaultStatusesColumn.NOMONEY,
//   BaseDefaultStatusesColumn.RETRIEVED,
//   BaseDefaultStatusesColumn.UNDERCALL,
//   BaseDefaultStatusesColumn.REMOVE,
//   BaseDefaultStatusesColumn.UNDEFINED,
//   // BaseDefaultStatusesColumn.IN_WORK,
//   BaseDefaultStatusesColumn.REMAINDER,
// ]

export const statusMapper = (status: BaseDefaultStatusesColumn): string => {
  switch (status) {
    case BaseDefaultStatusesColumn.SMARTERME:
      return 'Умник'
    case BaseDefaultStatusesColumn.SLIV:
      return 'Слив'
    case BaseDefaultStatusesColumn.NOMONEY:
      return 'Нет средств'
    case BaseDefaultStatusesColumn.RETRIEVED:
      return 'Списали'
    case BaseDefaultStatusesColumn.UNDERCALL:
      return 'Недозвон'
    case BaseDefaultStatusesColumn.UNDERCALL_D:
      return 'Недозвон'
    case BaseDefaultStatusesColumn.REMOVE:
      return 'Удалить'
    case BaseDefaultStatusesColumn.ALL_DAY:
      return 'Всего'
    case BaseDefaultStatusesColumn.ALL_DAY_D:
      return 'Всего'
    case BaseDefaultStatusesColumn.UNDEFINED:
      return 'Не существует'

    case BaseDefaultStatusesColumn.REMAINDER:
      return 'Непрозвон'
    case BaseDefaultStatusesColumn.PENDING:
      return 'В ожидании'
    case BaseDefaultStatusesColumn.IN_WORK:
      return 'В работе'
    case BaseDefaultStatusesColumn.RECALL:
      return 'Перезвон'
    default:
      return 'нет такого статуса'
  }
}

export const statusesSelect = [
  BaseDefaultStatusesColumn.SMARTERME,
  BaseDefaultStatusesColumn.SLIV,
  BaseDefaultStatusesColumn.NOMONEY,
  BaseDefaultStatusesColumn.RETRIEVED,
  BaseDefaultStatusesColumn.UNDERCALL,
  BaseDefaultStatusesColumn.REMOVE,
  BaseDefaultStatusesColumn.UNDEFINED,
  BaseDefaultStatusesColumn.REMAINDER,
].map((el) => ({ value: el, name: statusMapper(el) }))

export const roleNameMapper = (role: EUserRoles) => {
  switch (role) {
    case EUserRoles.BOSS:
      return 'Старший'
    case EUserRoles.ACCOUNTANT:
      return 'Бухгалтер'
    case EUserRoles.SUPER_ADMIN:
      return 'Супер Админ'
  }
}

export const roleSmallMapper = (role: EUserSmallRoles) => {
  switch (role) {
    case EUserSmallRoles.CLOSER:
      return 'Клоузер'
    case EUserSmallRoles.MANAGER:
      return 'Менеджер'
  }
}

export const sumCallResponseMapper = (val: IDyatel): IStatuses => ({
  dayCalls: val.daycalls,
  smarterme: val.smarterme,
  nomoney: val.nomoney,
  sliv: val.sliv,
  retrieved: val.retrieved,
  underCall: val.under_call,
  remove: val.remove,
  undefined: val.undefined,
})

export const expensesReasonMapper = (val: ExpensesReason) => {
  switch (val) {
    case ExpensesReason.CRM:
      return 'CRM'
    case ExpensesReason.PHONE:
      return 'Телефония'
    case ExpensesReason.BASE:
      return 'Базы'
    case ExpensesReason.ARENDA:
      return 'Аренда'
    case ExpensesReason.ZONT:
      return 'Зонт'
    case ExpensesReason.ZP_IT:
      return 'ЗП IT'
    case ExpensesReason.OTHER:
      return 'Другое'
    default:
      return 'Другое'
  }
}

export const subscriptionMapper = (val: SubscriptionType) => {
  switch (val) {
    case SubscriptionType.FIRST:
      return 'Первая'
    case SubscriptionType.SECOND:
      return 'Вторая'
    case SubscriptionType.THIRD:
      return 'Третья'
  }
}

export const crmUpdateTabsMapper = (val: UpdateCrmTabsType): string => {
  switch (val) {
    case UpdateCrmTabsType.PROPERTY:
      return 'Настройки'
    case UpdateCrmTabsType.SUBSCRIPTION:
      return 'Подписка'
    case UpdateCrmTabsType.PRICES:
      return 'Цены'
    case UpdateCrmTabsType.BALANCE:
      return 'Баланс'
  }
}

export const subscriptionStatusMapper = (val: SubscriptionStatus) => {
  switch (val) {
    case SubscriptionStatus.ACTIVE:
      return 'Активна'
    case SubscriptionStatus.FINISHED:
      return 'Закончена'
    case SubscriptionStatus.PENDING:
      return 'Ожидание'
  }
}

export const tariffTypeMapper = (type: TariffTypeEnum): string => {
  switch (type) {
    case TariffTypeEnum.CYBERSEC:
      return 'CyberSec'
    case TariffTypeEnum.EYE_OF_GOD:
      return 'Глаз Бога'
    case TariffTypeEnum.BROGO:
      return 'BROGO'
    case TariffTypeEnum.FREE:
      return 'FREE'
  }
}

export const serviceTypeMapper = (type: TariffTypeEnum): string => {
  switch (type) {
    case TariffTypeEnum.CYBERSEC:
      return 'CyberSec'
    case TariffTypeEnum.EYE_OF_GOD:
      return 'Глаз Бога'
    case TariffTypeEnum.BROGO:
      return 'BROGO'
    case TariffTypeEnum.FREE:
      return 'FREE'
    case TariffTypeEnum.DEPOSIT:
      return 'Поплонение'
    case TariffTypeEnum.MANUAL:
      return 'Поплонение мануально'
    default:
      return ''
  }
}

export const cabinetTypeMapper = (type: ClientCabinetType): string => {
  switch (type) {
    case ClientCabinetType.SberBank:
      return 'Сбербанк'
    default:
      return ''
  }
}

export const phoneTypeMapper = (type: string): string => {
  switch (type) {
    case 'phone':
      return 'Сотовая связь'
    case 'whatsApp':
      return 'WhatsApp'
    default:
      return ''
  }
}

export const currencyTypeMapper = (type: string): string => {
  switch (type) {
    case 'rub':
      return '₽'
    case 'usd':
      return '$'
    case 'eur':
      return '€'
    default:
      return ''
  }
}
